<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        学校 {{title}}
      </template>

      <template v-slot:content>
        <v-school-form @submit="submit" />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSchoolForm from '@/components/organizms/SchoolForm.vue'

export default {
  components: {
    VBaseCard,
    VSchoolForm,
  },

  beforeDestroy() {
    this.$store.commit('school/initialize')
  },

  computed: {
    title() {
      return this.$store.getters['school/title']
    },
  },

  methods: {
    async submit() {
      this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})
      const res = await this.$store.dispatch('school/submit')
      if (res.status === 'error') {
        this.$toasted.global.error({ message: res.message })
      } else {
        this.$toasted.global.success({ message: res.message })
        this.$router.push('/admin/schools')
      }
      this.$app.$refs.loading.close()
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
